/* Desayunos del Cielo · Ayudas de usabilidad móvil (QA 2026-10-23)
   - body.ddc-typing mientras se escribe en un campo (teclado abierto): oculta barras flotantes.
   - body.ddc-has-mobile-buy cuando la barra "Total / Continuar" del producto está activa: reserva su espacio
     y esconde el botón flotante de WhatsApp para que no tape la compra. */
(function () {
  var b = document.body;
  var isField = function (el) {
    return el && (/^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName)) &&
      !/^(checkbox|radio|range|button|submit|hidden)$/i.test(el.type || '');
  };
  var t;
  document.addEventListener('focusin', function (e) { if (isField(e.target)) { clearTimeout(t); b.classList.add('ddc-typing'); } });
  document.addEventListener('focusout', function () {
    clearTimeout(t);
    t = setTimeout(function () { if (!isField(document.activeElement)) b.classList.remove('ddc-typing'); }, 150);
  });

  var bar = document.querySelector('.ddc-mobile-buy');
  if (bar) {
    var sync = function () { b.classList.toggle('ddc-has-mobile-buy', bar.classList.contains('is-active')); };
    new MutationObserver(sync).observe(bar, { attributes: true, attributeFilter: ['class'] });
    sync();
  }
  // el cliente ya está armando su pedido: el popup de WhatsApp no debe interrumpirlo
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.ddc-config, ddc-configurator, [data-ddc-configurator]')) b.classList.add('ddc-configuring');
  });
})();
